import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Logo } from "./Logo";
import jackLogo from "../assets/jack-logo.png";

export function MaintenanceScreen({ message }) {
  return (
    <div
      data-testid="maintenance-screen"
      className="fixed inset-0 z-[9998] flex flex-col items-center justify-center text-center px-8 overflow-hidden"
      style={{ background: "linear-gradient(160deg,#5B3BE8 0%,#4B23CC 55%,#2E1585 100%)" }}
    >
      <div className="absolute inset-0 opacity-30 pointer-events-none"
        style={{ background: "radial-gradient(circle at 70% 20%, rgba(168,85,247,0.6), transparent 45%), radial-gradient(circle at 20% 80%, rgba(120,70,240,0.5), transparent 45%)" }} />
      <div className="relative flex flex-col items-center gap-6 max-w-md animate-fade-up">
        <Logo size={44} light />
        <div className="grid place-items-center w-20 h-20 rounded-full bg-white shadow-[0_10px_30px_rgba(0,0,0,0.25)] jc-coin">
          <div
            style={{
              width: 44, height: 44, backgroundColor: "#4B23CC",
              WebkitMask: `url(${jackLogo}) center / contain no-repeat`,
              mask: `url(${jackLogo}) center / contain no-repeat`,
            }}
          />
        </div>
        <h1 className="font-display text-3xl font-semibold text-white tracking-tight">We'll be right back</h1>
        <p className="text-white/80 text-base leading-relaxed">{message}</p>
        <p className="text-white/50 text-xs mt-2">Jack&nbsp;Cash&reg; &middot; Scheduled maintenance</p>
      </div>
      <Link
        to="/login"
        data-testid="maintenance-staff-login"
        aria-label="Staff login"
        title="Staff login"
        className="absolute bottom-7 grid place-items-center w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-sm ring-1 ring-white/15 transition-colors"
      >
        <Lock size={18} className="text-white" strokeWidth={2.4} />
      </Link>
      <style>{`
        @keyframes jcCoin { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
        .jc-coin { animation: jcCoin 2.6s ease-in-out infinite; }
      `}</style>
    </div>
  );
}
